import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) => {
  if (state && state.profileState) {
    return state.profileState;
  } else {
    return initialState;
  }
};


export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);
export const selectButtonLoading = createSelector(
  [selectDomain],
  (state) => state.buttonLoading
);


export const selectRegisterForm = createSelector(
  [selectDomain], 
  (state) => state.registerForm
);

export const selectPasswordForm = createSelector(
  [selectDomain],
  (state) => state.password
);
export const selectTogglePassword = createSelector(
  [selectDomain],
  (state) => state.togglePassword
);

export const selectToggleConfirmPassword = createSelector(
  [selectDomain],
  (state) => state.toggleConfirmPassword
);
export const selectEmailForm = createSelector(
  [selectDomain],
  (state) => state.emailForm
);
export const selectPageNo = createSelector(
  [selectDomain],
  (state) => state.pageNo
);
export const selectPageSize = createSelector(
  [selectDomain],
  (state) => state.pageSize
);
export const selectTotalRow = createSelector(
  [selectDomain],
  (state) => state.totalRow
);
export const selectTotalCount = createSelector(
  [selectDomain],
  (state) => state.totalCount
);

export const selectOrderBy = createSelector(
  [selectDomain],
  (state) => state.orderBy
);
export const selectOrderDir = createSelector(
  [selectDomain],
  (state) => state.orderDir
);
export const selectSearch = createSelector(
  [selectDomain],
  (state) => state.search
);
export const selectOrderList = createSelector(
  [selectDomain],
  (state) => state.orderList
);
export const selectOrderDetails = createSelector(
  [selectDomain],
  (state) => state.orderDetails
);

export const selectHoldUpdatedItems = createSelector(
  [selectDomain],
  (state) => state.holdUpdatedItems
);
export const selectNotificationList = createSelector(
  [selectDomain],
  (state) => state.notificationList
);